import {all, call, fork, put, select, takeLatest} from 'redux-saga/effects'
import {push} from 'react-router-redux'
import {createPivotTableWatcher} from './pivotTable'
import {difference, get, isEmpty, isNil} from 'lodash'
import {quotePivotTableFields} from 'containers/quotePivotTable'
import * as invoicingActions from '../actions/invoicing'
import * as pivotTableActions from '../actions/pivotTable'
import {snackbarMessage} from 'actions/snackbar'
import * as dialogActions from '../actions/dialog'
import {getDateFilters} from 'helpers/dateRange'
import {
  getSalesAnalysisInvoiceFilterParams,
  InvoiceType,
} from 'helpers/invoices'
import types from '../actions/types'
import {generalError} from '../actions/index'
import {
  getDeliveredNotInvoiced,
  getDeliveredNotInvoicedStatus,
  getInvoices,
  getInvoiceSelector,
  getLastInvoice,
  getLastInvoiceItems,
  getPurchaseInvoices,
  getReceivedNotInvoiced,
  getSelectedInvoice,
  getSelectedInvoiceItems,
} from 'selectors/invoices'
import {updateSelectedInvoices} from 'actions/contacts'
import {PriceMode} from 'helpers/orders'
import onboardingActions from 'actions/onboarding'
import SKILLS from 'helpers/onboarding/skills'
import {
  filterLogItemsToDelete,
  getInvoicingFilterParams,
  getPurchaseInvoicingFilterParams,
  mapNegativeIdInvoiceItemsAgainstCurrent,
} from 'helpers/invoices'
import {getInvoiceFinancialYearStart} from 'selectors/settings'
import {deliveredNotInvoicedPivotTableKey} from 'reducers/invoicingContext/notInvoiced'
import {invoicingContextInvoicesPivotTableKey} from 'reducers/invoicingContext/invoices'
import {getSearch} from 'selectors/pivotTable'
import {getSearchTerm} from 'helpers/string'
import {getQuotePersonParams, QuoteStatus} from 'helpers/quotes'
import {updateParamsForOrderType} from 'helpers/opportunities'
import {invoiceHistoryPivotTableKey, invoiceItemsPivotTableKey} from 'reducers/invoicingContext/selected'
import {invoicingContextSelectorInvoicesPivotTableKey} from 'reducers/invoicingContext/selector'
import {getLocationPath} from 'selectors/routing'
import {getSelectedCompanyId, getSelectedContactId} from 'selectors/contacts'
import {getPathForInvoice, getPathForInvoicePreview} from 'helpers/navigation'
import {invoicingContextReceivedNotInvoicedPivotTableKey} from 'reducers/invoicingContext/receivedNotInvoiced'
import {PurchaseOrderStatus} from 'helpers/purchasing/purchaseOrders'
import {purchasingContextSelectorOrdersPivotTableKey} from 'reducers/purchasingContext/selector'
import {getReceivedNotInvoicedParams} from 'helpers/purchaseOrders'
import {copyInvoiceItem, withInvoiceItemGuid} from 'helpers/invoiceItems'
import {ContactEmailType, getFormDataFor} from 'helpers/email/enum'
import {iconNames} from 'components/icon'
import {invoicingContextPurchasingPivotTableKey} from 'reducers/invoicingContext/purchasing'
import {
  salesContextSalesAnalysisInvoicesViewPivotTableKey,
} from 'reducers/salesContext/salesAnalysisView/invoiceDataSource'
import {getUser, getUserSettings} from 'selectors/auth'
import {isBulkInvoicesFeatureToggleEnabled} from 'helpers/user'
import {getHomeContacts, getTeamMembers, getTeams} from 'selectors/data'
import {getContactsForSalesAnalysisTeamOrUserOptions, getTeamOrUserOptions} from 'helpers/teams'
import {filterDormantContacts} from 'helpers/contacts'
import QuoteHelper from '../helpers/quotes'
import {getFiltersForDataSource, getSalesAnalysisUsersFilterOptions} from 'helpers/sales'
import {loadInvoiceSummaryInfoFailure, loadInvoiceSummaryInfoSuccess} from 'actions/invoicing'
import {deSelectAllRows} from "actions/pivotTable"

const loadInvoiceFields = {
  default: true,
  overrides: true,
  printOptions: true,
  values: true,
  company: {
    default: true,
    companyLogoImage: true,
    accountingcompany: true,
    contacts: {
      forename: true,
      surname: true,
      companyType: true,
      type: true,
      email: true,
    },
  },
  currency: true,
  creator: true,
  contact: {
    default: true,
    accountmanager: true,
  },
  address: true,
  order: {
    default: true,
    orderItems: true,
    deliveryNotes: {
      id: true,
    },
    estimator: true,
    salesman: true,
    creator: true,
  },
  renewaltype: true,
}

const salesAnalysisInvoiceFields = {
  ...loadInvoiceFields,
  contact: {
    ...loadInvoiceFields.contact,
    userfields: true,
  },
}

const saveInvoiceFields = {
  ...loadInvoiceFields,
  invoiceitems: {
    default: true,
    orderItem: true,
  },
}

export const invoicePivotTableFields = {
  default: true,
  company: {
    default: true,
  },
  contact: {
    id: true,
    companyId: true,
    forename: true,
    surname: true,
  },
  createdby: {
    id: true,
    companyId: true,
    forename: true,
    surname: true,
  },
  order: {
    default: true,
    estimator: true,
    userfields: true,
  },
  taxcode: true,
  currency: true,
  values: true,
  total: true,
}

const summaryInfoFields = {
  default: true,
}

export const purchaseInvoicePivotTableFields = {
  default: true,
  company: {
    default: true,
  },
  contact: {
    id: true,
    companyId: true,
    forename: true,
    surname: true,
    phone: true,
  },
  createdby: {
    id: true,
    companyId: true,
    forename: true,
    surname: true,
  },
  purchaseOrder: {
    default: true,
    id: true,
    orderId: true,
    estimator: true,
  },
  taxcode: true,
  currency: true,
  values: true,
  total: true,
}


export default (api) => {

  function* loadInvoice({invoiceId}) {
    try {
      // Load the selected invoice in full
      const response = yield call(api.invoice.getOne, invoiceId, loadInvoiceFields)
      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          const invoice = data.result
          yield put(invoicingActions.loadInvoiceSuccess(invoice))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.loadInvoiceFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* loadBatchInvoices({batchNumber, isPurchaseInvoice}) {
    try {
      const apiCall = isPurchaseInvoice ? api.purchaseInvoice.get : api.invoice.get
      const params = {
        batchNumber,
      }
      const fields = {
        accountingInvoiceId: true,
        company: {
          id: true,
          name: true,
        },
        contact: {
          id: true,
          email: true,
        },
        desc: true,
        notPosted: true,
        posted: true,
        postedTo: true,
        postError: true,
        postStatus: true,
        problemList: true,
        ref: true,
        type: true,
      }

      const response = yield call(apiCall, params, fields)
      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          const invoices = data.result
          yield put(invoicingActions.loadBatchInvoicesSuccess(invoices))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.loadBatchInvoicesFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  // Requires either one of invoiceId or invoice and optionally routeParams
  function* selectInvoice({invoiceId, invoice, route, companyId = null, contactId = null}) {
    try {
      if (invoiceId == null && invoice != null) invoiceId = invoice.id

      if (companyId === null && contactId === null) {
        if (route) {
          // Use existing route if provided
          contactId = route.match.params.contactId
          companyId = route.match.params.companyId
        } else if (invoice) {
          // Navigate within contacts if already present
          const route = yield select(getLocationPath)

          if (route.startsWith('/contacts')) {
            contactId = get(invoice, 'contactId')
            companyId = get(invoice, 'companyId')
          }

          if (companyId === null) {
            companyId = get(invoice, 'companyId')
          }
        }
      }


      // Make appropriate transition
      yield put(push(getPathForInvoice(invoiceId, companyId, contactId)))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  // { invoiceId, invoice, route } are provided.
  function* previewInvoice({invoiceId}) {
    const selectedContactId = yield select(getSelectedContactId)
    const selectedCompanyId = yield select(getSelectedCompanyId)
    yield put(push(getPathForInvoicePreview(invoiceId, selectedCompanyId, selectedContactId)))
  }

  function* saveInvoice({silent}) {
    silent = (isNil(silent)) ? false : silent
    try {
      const invoice = yield select(getSelectedInvoice)
      if (invoice) {
        let items = yield select(state => state.invoicingContext.selected.items.data.data)
        const deletedItems = yield select(state => state.invoicingContext.selected.deletedItems)
        const {overrides, printOptions} = invoice

        items = items.map(item => ({
          ...item,
          id: item.isNew ? -1 : item.id,
        }))

        if (silent === false)
          yield put(snackbarMessage('Saving your changes...', iconNames.loading, false, false))

        const response = yield call(api.invoice.update, {
          invoice,
          items,
          deletedItems,
          overrides,
          printOptions,
          commit: true,
        }, saveInvoiceFields)

        yield api.handleResponse(
          response,
          function* onOk() {
            // yield put(invoicingActions.saveInvoiceSuccess(data)) // TODO: defer to web socket !
            if (silent === false) yield put(snackbarMessage('Your changes have been saved', iconNames.tick, true))
          },
          function* onFail(key, message, code) {
            yield put(invoicingActions.saveInvoiceFailure(message, code))
          })
      }
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* injectInvoiceItems({data}) {
    try {
      // Inject the result to update the ids of the invoice items.
      yield put(invoicingActions.injectSelectedInvoiceItems(data.result.invoiceItems))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* updateInvoiceItems({invoiceItems, undo = false}) {
    try {
      yield put(pivotTableActions.updateData(invoiceItemsPivotTableKey, invoiceItems))
      if (!undo) yield call(invoiceChangeLogWorker)
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* addItem({invoiceItem}) {
    yield put(pivotTableActions.addEntity(invoiceItemsPivotTableKey, withInvoiceItemGuid(invoiceItem)))
    // yield call(invoiceChangeLogWorker) - triggered by the above action
  }

  function* addItemAtIndex({invoiceItem, index}) {
    yield put(pivotTableActions.addEntityAtIndex(invoiceItemsPivotTableKey, withInvoiceItemGuid(invoiceItem), index))
    // yield call(invoiceChangeLogWorker) - triggered by the above action
  }

  function* editItem({invoiceItem, index}) {
    yield put(pivotTableActions.editEntity(invoiceItemsPivotTableKey, invoiceItem, index))
    yield call(invoiceChangeLogWorker)
  }

  function* reorderItem({fromIndex, toIndex}) {
    try {
      const curItems = yield select(state => state.invoicingContext.selected.items.data.data)
      const newItems = [
        ...curItems.slice(0, fromIndex),
        ...curItems.slice(fromIndex + 1),
      ]
      newItems.splice(toIndex, 0, curItems[fromIndex])
      newItems.forEach((e, i) => {
        e.index = i
        e.sortOrder = i + 1
        e.lineItemLetter = QuoteHelper.getOrderItemLetter(e.lineItem)
      })
      newItems.sort((a, b) => a.index - b.index)
      yield put(pivotTableActions.setEntities(invoiceItemsPivotTableKey, newItems))
      yield call(invoiceChangeLogWorker)
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* copyItem({invoiceItem}) {
    try {
      const newInvoiceItem = copyInvoiceItem(invoiceItem)
      yield put(pivotTableActions.copyEntity(invoiceItemsPivotTableKey, newInvoiceItem))
      yield put(pivotTableActions.deSelectAllRows(invoiceItemsPivotTableKey))
      yield call(invoiceChangeLogWorker)
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* copyItems({invoiceItems}) {
    try {
      if (!isNil(invoiceItems)) {
        for (const i in invoiceItems) {
          const invoiceItem = invoiceItems[i]
          const newInvoiceItem = copyInvoiceItem(invoiceItem)
          yield put(pivotTableActions.addEntity(
            invoiceItemsPivotTableKey,
            newInvoiceItem,
            {
              autoSave: false,
            }))
        }
        yield put(pivotTableActions.deSelectAllRows(invoiceItemsPivotTableKey))
      }
      yield call(invoiceChangeLogWorker)
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* deleteItem({invoiceItem}) {
    try {
      let items = yield select(state => state.invoicingContext.selected.items.data.data)
      items = items.filter(item => item !== invoiceItem).map((item, itemIndex) => {
        return {
          ...item,
          sortOrder: itemIndex + 1,
          lineItemLetter: QuoteHelper.getOrderItemLetter(itemIndex + 1),
        }
      })
      yield put(invoicingActions.updateInvoiceItems(items))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* deleteItems({invoiceItems, undo = false}) {
    try {
      const items = yield select(state => state.invoicingContext.selected.items.data.data)
      const remainingItems = difference(items, invoiceItems).map((item, itemIndex) => ({
        ...item,
        sortOrder: itemIndex + 1,
        lineItemLetter: QuoteHelper.getOrderItemLetter(itemIndex + 1),
      }))
      yield put(invoicingActions.updateInvoiceItems(remainingItems, undo))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* deleteAllItems() {
    try {
      const items = yield select(state => state.invoicingContext.selected.items.data.data)
      yield put(invoicingActions.deleteInvoiceItems(items)) // must do this to record the deletions
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* updateFromJob({items = true, remaining = false, adjustment, percentage, deliveryNoteIds}) {
    try {
      const invoice = yield select(getSelectedInvoice)
      const isCreditNote = get(invoice, 'creditNote', false)
      const noteName = isCreditNote ? 'credit note' : 'invoice'

      if (invoice) {
        yield put(snackbarMessage(`Updating your ${noteName}...`, iconNames.loading, false, false))
        const params = {
          invoiceId: invoice.id,
          items,
          remaining,
          adjustment,
          percentage,
          deliveryNoteIds: isEmpty(deliveryNoteIds) ? [] : deliveryNoteIds,
        }
        const response = yield call(api.invoice.updateFromJob, params, saveInvoiceFields)

        yield api.handleResponse(
          response,
          function* onOk() {
            // yield put(invoicingActions.updateFromJobSuccess(data)) // TODO: defer to web socket !
            yield call(invoiceChangeLogWorker)
            yield put(snackbarMessage('Your items have been added', iconNames.tick, true))
          },
          function* onFail(key, message, code) {
            yield put(invoicingActions.updateFromJobFailure(message, code))
          })
      }
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* markPosted({invoiceIds}) {
    try {
      yield put(snackbarMessage('Updating your invoices...', iconNames.loading, false, false))
      const response = yield call(api.invoice.markPosted, {id: invoiceIds})

      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.markPostedSuccess(data))
          const snackbarLabel = invoiceIds.length === 1
            ? 'Your invoice has been marked as posted'
            : 'Your invoices have been marked as posted'
          yield put(snackbarMessage(snackbarLabel, iconNames.tick, true))

          yield put(deSelectAllRows(invoicingContextInvoicesPivotTableKey))
          yield put(deSelectAllRows(invoicingContextPurchasingPivotTableKey))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.markPostedFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* unmarkPosted({invoiceIds}) {
    try {
      yield put(snackbarMessage('Updating your invoices...', iconNames.loading, false, false))
      const response = yield call(api.invoice.unmarkPosted, {id: invoiceIds})

      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.unmarkPostedSuccess(data))
          yield put(snackbarMessage(invoiceIds.length === 1
            ? 'Your invoice has been unmarked as posted'
            : 'Your invoices have been unmarked as posted', iconNames.tick, true))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.unmarkPostedFailure(message, code))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* markPurchasePosted({invoiceIds}) {
    try {
      yield put(snackbarMessage('Updating your invoices...', iconNames.loading, false, false))
      const response = yield call(api.purchaseInvoice.markPosted, {id: invoiceIds})

      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.markPurchasePostedSuccess(data))
          yield put(snackbarMessage(invoiceIds.length === 1
            ? 'Your invoice has been marked as posted'
            : 'Your invoices have been marked as posted', iconNames.tick, true))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.markPurchasePostedFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* unmarkPurchasePosted({invoiceIds}) {
    try {
      yield put(snackbarMessage('Updating your invoices...', iconNames.loading, false, false))
      const response = yield call(api.purchaseInvoice.unmarkPosted, {id: invoiceIds})

      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.unmarkPurchasePostedSuccess(data))
          yield put(snackbarMessage(invoiceIds.length === 1
            ? 'Your invoice has been unmarked as posted'
            : 'Your invoices have been unmarked as posted', iconNames.tick, true))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.unmarkPurchasePostedFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* saveInvoiceFromPivotTableAction({key, save = true}) {
    try {
      if (save && key === 'invoicingContext.selected.items') yield call(invoiceChangeLogWorker)
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* addInvoiceForOrder(
    {
      order,
      invoiceCreateType,
      deliveryNoteIds,
      fixedPercentage,
      fixedPriceAdjustment,
      isCreditNote,
      invoiceDate,
    }) {
    try {
      const invoice = {
        orderId: order.id,
        desc: order.desc,
        invoiceDate: isNil(invoiceDate)
          ? new Date().getTime()
          : invoiceDate,
        type: InvoiceType.standard,
        companyId: order.companyId,
        contactId: order.contactId,
        taxCodeId: order.taxCodeId,
        taxRate: order.taxRate,
        currencyId: order.currencyId,
        currencyRate: order.currencyRate,
        orderNumber: order.orderNumber,
        discountPc: order.priceMode.id === PriceMode.fixed_margin
          ? 0
          : order.discountPc,
        termsText: order.paymentTerms,
        notes: order.notes,
        creditNote: isCreditNote,
        invoiceCreateType,
        fixedPriceAdjustment,
        deliveryNoteIds,
        fixedPercentage,
      }
      yield put(invoicingActions.addInvoice(invoice))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* addInvoice({invoice}) {
    try {

      const isCreditNote = get(invoice, 'creditNote', false)
      const noteName = isCreditNote ? 'credit note' : 'invoice'
      yield put(snackbarMessage(`Creating your ${noteName}...`, iconNames.loading, false, false))
      const response = yield call(api.invoice.add, {invoice})

      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.addInvoiceSuccess(data))
          yield put(snackbarMessage(
            `${isCreditNote ? 'Credit Note' : 'Invoice'} ${data.result.ref} has been created`,
            iconNames.tick,
            true))

          // Close the dialog (if any) and go to the invoice editor
          yield put(dialogActions.hideAddInvoiceDialog())
          yield call(selectInvoice, {invoiceId: data.result.id, invoice: data.result})

          const skill = yield select(state => state.onboarding.skills.ADD_INVOICE)
          if (skill.active) yield put(onboardingActions.skillPage(SKILLS.ADD_INVOICE.key, 3))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.addInvoiceFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* invoiceChangeLogWorker() {
    try {
      // grab the selected invoice
      const invoice = yield select(getSelectedInvoice)

      // now save the change - this is a bit messy but should prevent any weird update issues
      yield call(saveInvoice, {silent: true})

      // We grab the invoice items after update, because we want the correct ids from the server.
      const invoiceItems = yield select(getSelectedInvoiceItems)

      // compose the change action - reducers will store the result
      yield put(invoicingActions.logInvoiceChange(invoice, invoiceItems))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* invoiceChangeUndoWorker() {
    try {
      // grab the selected invoice.
      //const currentInvoice = yield select(getSelectedInvoice)
      const currentInvoiceItems = yield select(getSelectedInvoiceItems) || []
      const invoice = yield select(getLastInvoice)
      const invoiceItems = yield select(getLastInvoiceItems) || []

      // find any added items and mark them as deleted
      const newInvoiceItems = currentInvoiceItems.filter(i =>
        invoiceItems.findIndex(item => item.id === i.id) === -1) || []
      if (newInvoiceItems.length > 0) {
        yield put(pivotTableActions.updateData(invoiceItemsPivotTableKey, []))
      }

      const mappedInvoiceItems = mapNegativeIdInvoiceItemsAgainstCurrent(currentInvoiceItems, invoiceItems)
      const filteredCurrentInvoiceItems = filterLogItemsToDelete(currentInvoiceItems, mappedInvoiceItems)

      if (filteredCurrentInvoiceItems.length > 0) {
        yield put(invoicingActions.deleteInvoiceItems(filteredCurrentInvoiceItems, null, true))
      }

      yield put(invoicingActions.injectSelectedInvoiceItems(mappedInvoiceItems))
      yield put(invoicingActions.undoInvoiceChangeData(invoice))

      // now save the change
      yield put(invoicingActions.saveInvoice(true))
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* sendEmail({emailDetails}) {

    try {

      const {isCreditNote} = emailDetails
      const noteName = isCreditNote ? 'credit note' : 'invoice'
      const formData = getFormDataFor(emailDetails, ContactEmailType.INVOICE_ATTACHMENT)
      yield put(snackbarMessage(`Sending your ${noteName}...`, iconNames.loading, false, false))
      const response = yield call(api.invoice.sendEmail, formData)
      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.sendInvoiceEmailSuccess(data))
          yield put(snackbarMessage(`Your ${noteName} has been sent`, iconNames.tick, true))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.sendInvoiceEmailFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* addInvoiceHistory({params}) {
    try {
      const response = yield call(api.invoice.addHistory, params)
      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(invoicingActions.addInvoiceHistorySuccess(data))
        },
        function* onFail(key, message, code) {
          yield put(invoicingActions.addInvoiceHistoryFailure(message, code))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* selectAllInvoiceItems() {
    let selectedInvoiceItems = yield select(state => state.invoicingContext.selected.items.data.data)
    selectedInvoiceItems = selectedInvoiceItems.map((orderItem, index) => {
      orderItem['selected'] = true
      orderItem['index'] = index
      return orderItem
    })
    yield put(pivotTableActions.selectAllRows(invoiceItemsPivotTableKey))
    yield put(updateSelectedInvoices(selectedInvoiceItems))
  }

  function* deSelectAllInvoiceItems() {
    let selectedInvoiceItems = yield select(state => state.invoicingContext.selected.items.data.data)
    selectedInvoiceItems = selectedInvoiceItems.map((orderItem, index) => {
      orderItem['selected'] = false
      orderItem['index'] = index
      return orderItem
    })
    yield put(pivotTableActions.deSelectAllRows(invoiceItemsPivotTableKey))
    yield put(updateSelectedInvoices(selectedInvoiceItems))
    yield put(invoicingActions.removeSelectedInvoiceItems())
  }

  function* invoiceSelectorSearch({search}) {
    yield put(pivotTableActions.search('invoicingContext.selector.orders', search))
  }

  function* invoiceUpdateFilters({filters}) {
    yield put(pivotTableActions.updateFilters('invoicingContext.selector.orders', filters))
  }

  function* invoiceViewUpdateFilters({filters}) {
    yield put(pivotTableActions.updateFilters(invoicingContextInvoicesPivotTableKey, filters))
  }

  function* loadInvoiceSummaryInfo({index, params}) {
    try {
      const response = yield call(api.invoice.summary, params, summaryInfoFields)
      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          yield put(loadInvoiceSummaryInfoSuccess(index, data.result))
        },
        function* onFail(key, message, code) {
          yield put(loadInvoiceSummaryInfoFailure(message, code))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* createBulkInvoices({orders, invoicedDateOption}) {
    try {
      const orderIds = (orders || []).map(order => order.id).filter(Boolean)
      if (isEmpty(orderIds)) return

      yield put(snackbarMessage('Creating invoices', iconNames.loading, false, false))

      const response = yield call(api.invoice.createBulk, {
        orderIds,
        invoicedDateOption,
      })

      yield api.handleResponse(
        response,
        function* onOk() {
          yield put(snackbarMessage('Invoices created', iconNames.tick, true))
          yield put(pivotTableActions.deSelectAllRows(deliveredNotInvoicedPivotTableKey))
          yield put(pivotTableActions.requestData(deliveredNotInvoicedPivotTableKey))
        },
        function* onFail(key, message) {
          yield put(generalError(message))
        })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* myWatcher() {
    yield all([
      takeLatest(types.INVOICING_SELECT_INVOICE, selectInvoice),
      takeLatest(types.INVOICING_LOAD_SUMMARY_INFO_ATTEMPT, loadInvoiceSummaryInfo),
      takeLatest(types.INVOICING_LOAD_INVOICE_ATTEMPT, loadInvoice),
      takeLatest(types.INVOICING_LOAD_BATCH_INVOICES_ATTEMPT, loadBatchInvoices),
      takeLatest(types.INVOICING_INVOICE_SAVE_ATTEMPT, saveInvoice),
      takeLatest(types.INVOICING_INVOICE_SAVE_SUCCESS, injectInvoiceItems),
      takeLatest(types.INVOICING_INVOICE_UPDATE_FROM_JOB_SUCCESS, injectInvoiceItems),
      takeLatest(types.INVOICING_ADD_INVOICE_FOR_ORDER, addInvoiceForOrder),
      takeLatest(types.INVOICING_INVOICE_ADD_ATTEMPT, addInvoice),
      takeLatest(types.INVOICING_BULK_INVOICES_ADD, createBulkInvoices),
      takeLatest(types.INVOICING_INVOICE_PREVIEW_INVOICE, previewInvoice),
      takeLatest(types.INVOICING_INVOICE_SEND_EMAIL_ATTEMPT, sendEmail),
      takeLatest(types.INVOICING_MARK_POSTED_ATTEMPT, markPosted),
      takeLatest(types.INVOICING_UNMARK_POSTED_ATTEMPT, unmarkPosted),
      takeLatest(types.PURCHASE_INVOICING_MARK_POSTED_ATTEMPT, markPurchasePosted),
      takeLatest(types.PURCHASE_INVOICING_UNMARK_POSTED_ATTEMPT, unmarkPurchasePosted),
      takeLatest(types.INVOICING_INVOICE_ADD_INVOICE_ITEM, addItem),
      takeLatest(types.INVOICING_INVOICE_ADD_INVOICE_ITEM_AT_INDEX, addItemAtIndex),
      takeLatest(types.INVOICING_INVOICE_EDIT_INVOICE_ITEM, editItem),
      takeLatest(types.INVOICING_INVOICE_DELETE_INVOICE_ITEM, deleteItem),
      takeLatest(types.INVOICING_INVOICE_DELETE_INVOICE_ITEMS, deleteItems),
      takeLatest(types.INVOICING_INVOICE_DELETE_ALL_INVOICE_ITEMS, deleteAllItems),
      takeLatest(types.INVOICING_INVOICE_COPY_INVOICE_ITEM, copyItem),
      takeLatest(types.INVOICING_INVOICE_COPY_INVOICE_ITEMS, copyItems),
      takeLatest(types.INVOICING_INVOICE_REORDER_INVOICE_ITEM, reorderItem),
      takeLatest(types.INVOICING_INVOICE_UPDATE_FROM_JOB_ATTEMPT, updateFromJob),
      takeLatest(types.INVOICING_INVOICE_UPDATE_ITEMS, updateInvoiceItems),
      takeLatest(types.INVOICING_INVOICE_UPDATE_INVOICE, invoiceChangeLogWorker),
      takeLatest(types.INVOICING_INVOICE_UPDATE_PROPERTY, invoiceChangeLogWorker),
      takeLatest(types.INVOICING_UNDO_CHANGE, invoiceChangeUndoWorker),
      takeLatest(types.INVOICING_INVOICE_SELECT_ALL_INVOICE_ITEMS, selectAllInvoiceItems),
      takeLatest(types.INVOICING_INVOICE_DESELECT_ALL_INVOICE_ITEMS, deSelectAllInvoiceItems),
      takeLatest(types.INVOICING_INVOICE_SELECTOR_SEARCH, invoiceSelectorSearch),
      takeLatest(types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS, invoiceUpdateFilters),
      takeLatest(types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS, invoiceViewUpdateFilters),
      takeLatest(types.INVOICING_INVOICE_HISTORY_ADD_ATTEMPT, addInvoiceHistory),
      // Listen to inline pivot table changes
      // IMPORTANT! It is significant that we are specifically listening to
      // addEntity and editData and NOT anything else. These two are invoked
      // PRIOR to committing changes, whereas some other calls, such as
      // updateData are invoked AFTER comitting changes
      // (see actions/invoicing.js:injectSelectedInvoiceItems) and so responding
      // to that here causes an infinite loop.
      takeLatest(types.PIVOT_TABLE_ADD_ENTITY, saveInvoiceFromPivotTableAction),
      takeLatest(types.PIVOT_TABLE_EDIT_DATA, saveInvoiceFromPivotTableAction),
      takeLatest(types.PIVOT_TABLE_EDIT_DATA_MULTI, saveInvoiceFromPivotTableAction),
      takeLatest(types.PIVOT_TABLE_SAVE_ATTEMPT, saveInvoiceFromPivotTableAction),
    ])
  }

  const invoicesPivotTable = createPivotTableWatcher(
    api.invoice,
    invoicingContextInvoicesPivotTableKey,
    [
      types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS,
      types.ACCOUNTING_INVOICE_POST_ASYNC_SUCCESS,
      types.INVOICING_MARK_POSTED_SUCCESS,
      types.INVOICING_UNMARK_POSTED_SUCCESS,
    ],
    state => {
      const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
      const filters = getInvoices(state)
      const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)
      const {status, companyId, estimatorId, orderTypeId} = filters

      const searchTerm = getSearch(state, invoicingContextInvoicesPivotTableKey)

      return getInvoicingFilterParams(
        searchTerm, status, companyId, estimatorId, targetStart, targetEnd, orderTypeId
      )
    },
    invoicePivotTableFields)

  const invoiceItemsPivotTable = createPivotTableWatcher(
    api.invoiceItem,
    invoiceItemsPivotTableKey,
    [types.INVOICING_LOAD_INVOICE_SUCCESS],
    state => {
      const invoice = getSelectedInvoice(state)
      return {
        limit: 2000,
        invoiceId: get(invoice, 'id', null),
      }
    },
    {
      default: true,
      orderItem: true,
    })

  const invoiceHistoryPivotTable = createPivotTableWatcher(
    api.invoiceHistory,
    invoiceHistoryPivotTableKey,
    [
      types.INVOICING_INVOICE_LOAD_HISTORY_ATTEMPT,
    ],
    state => {
      const invoice = getSelectedInvoice(state)
      return {
        invoiceId: [
          get(invoice, 'id', null),
        ],
      }
    },
    {
      default: true,
      contact: true,
    })

  const notInvoicedPivotTable = createPivotTableWatcher(
    api.quote,
    deliveredNotInvoicedPivotTableKey,
    [types.INVOICING_NOT_INVOICED_UPDATE_FILTERS],
    state => {
      const bulkInvoicesEnabled = isBulkInvoicesFeatureToggleEnabled(getUser(state))
      const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
      const filters = getDeliveredNotInvoiced(state)
      const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)
      const {
        companyId,
        estimatorId,
        salesPersonId,
        selectedRoles,
        selectedContacts,
        orderTypeId,
        dateTypes,
      } = filters

      const params = {}

      const searchTerm = getSearch(state, deliveredNotInvoicedPivotTableKey)
      if (getSearchTerm(searchTerm))
        params['searchTerm'] = searchTerm

      if (!isEmpty(companyId))
        params['companyId'] = companyId.map(option => option.value)

      const hasDateRange = !isNil(targetStart) && !isNil(targetEnd)

      if (bulkInvoicesEnabled) {
        getQuotePersonParams(params, selectedContacts, selectedRoles)
        updateParamsForOrderType(params, orderTypeId)

        if (hasDateRange) {
          dateTypes.forEach(dateType => {
            params[`${dateType}Start`] = targetStart
            params[`${dateType}End`] = targetEnd
          })
        }
      } else {
        if (!isEmpty(estimatorId))
          params['estimatorId'] = estimatorId

        if (!isEmpty(salesPersonId))
          params['salesmanId'] = salesPersonId

        if (hasDateRange) {
          params['deliveredStart'] = targetStart
          params['deliveredEnd'] = targetEnd
        }
      }

      params.status = bulkInvoicesEnabled
        ? getDeliveredNotInvoicedStatus(state)
        : [QuoteStatus.delivered, QuoteStatus.partDelivered]

      params.allRevisions = true
      params.showCompleted = true
      params.showInactive = true
      params.total = true
      return params
    },
    quotePivotTableFields)


  const purchaseInvoicesPivotTable = createPivotTableWatcher(
    api.purchaseInvoice,
    invoicingContextPurchasingPivotTableKey,
    [
      types.INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS,
      types.ACCOUNTING_PURCHASE_INVOICE_POST_ASYNC_SUCCESS,
      types.PURCHASE_INVOICING_MARK_POSTED_SUCCESS,
      types.PURCHASE_INVOICING_UNMARK_POSTED_SUCCESS,
    ],
    state => {
      const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
      const filters = getPurchaseInvoices(state)
      const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)
      const {status, companyId, creatorId} = filters
      const searchTerm = getSearch(state, 'invoicingContext.purchasing.pivotTable')

      return getPurchaseInvoicingFilterParams(searchTerm, status, companyId, creatorId, targetStart, targetEnd)
    },
    purchaseInvoicePivotTableFields)


  const invoiceSelectorInvoicesPivotTable = createPivotTableWatcher(
    api.invoice,
    invoicingContextSelectorInvoicesPivotTableKey,
    [
      types.INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS,
      types.INVOICING_INVOICE_SELECTOR_SEARCH,
    ],
    state => {
      const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
      const filters = getInvoiceSelector(state)
      const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)
      const {status, companyId, estimatorId} = filters
      const searchTerm = getSearch(state, invoicingContextSelectorInvoicesPivotTableKey)

      return getInvoicingFilterParams(searchTerm, status, companyId, estimatorId, targetStart, targetEnd)
    },
    invoicePivotTableFields)

  const invoiceSelectorItemsPivotTable = createPivotTableWatcher(
    api.invoiceItem,
    'invoicingContext.selector.items',
    [types.INVOICING_INVOICE_SELECTOR_LOAD_ITEMS],
    state => ({invoiceId: state.invoicingContext.selector.itemsInvoice}),
    {
      default: true,
      taxcode: true,
    })

  const receivedNotInvoicedPivotTable = createPivotTableWatcher(
    api.purchaseOrder,
    invoicingContextReceivedNotInvoicedPivotTableKey,
    [types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS],
    state => {
      const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
      const filters = getReceivedNotInvoiced(state)

      const statusTypes = [
        PurchaseOrderStatus.received,
        PurchaseOrderStatus.partReceived,
      ]
      const {companies, raisedBy, dateTypes, printedEmailed} = filters
      const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)

      return getReceivedNotInvoicedParams(
        getSearch(state, purchasingContextSelectorOrdersPivotTableKey),
        statusTypes,
        companies,
        raisedBy,
        dateTypes,
        targetStart,
        targetEnd,
        printedEmailed,
        true)
    },
    {
      default: true,
      contact: true,
      company: true,
      creator: true,
      modifier: true,
      userfields: true,
      totalInvoiced: true,
      receivedValue: true,
    })


  const invoiceSalesAnalysisPivotTable = createPivotTableWatcher(
    api.invoice,
    salesContextSalesAnalysisInvoicesViewPivotTableKey,
    [
      types.SALES_UPDATE_SALES_ANALYSIS_INVOICING_FILTERS,
    ],
    state => {
      const filters = getFiltersForDataSource(state)
      const {
        statusTypes,
        companies,
        userTypes,
        showDormants,
        contacts,
        orderTypeId,
      } = filters

      const user = getUser(state)
      const teams = getTeams(state)
      const teamMembers = getTeamMembers(state)
      const homeContacts = getHomeContacts(state, true)
      const invoiceFinancialYearStart = getInvoiceFinancialYearStart(state)
      const {targetStart, targetEnd} = getDateFilters(filters, invoiceFinancialYearStart)
      const userSettings = getUserSettings(state)

      const teamUserOptions =
        getSalesAnalysisUsersFilterOptions(user, teams, teamMembers, homeContacts, 'Invoices')
      let teamOrUserOptions = getTeamOrUserOptions(teamUserOptions, contacts)

      if (isEmpty(teamOrUserOptions) && !isEmpty(teamUserOptions))
        teamOrUserOptions = [teamUserOptions[0].value]

      const ownerIds = getContactsForSalesAnalysisTeamOrUserOptions(
        teamOrUserOptions,
        teams,
        teamMembers,
        filterDormantContacts(homeContacts, showDormants))

      return getSalesAnalysisInvoiceFilterParams(
        getSearch(state, salesContextSalesAnalysisInvoicesViewPivotTableKey),
        statusTypes,
        companies,
        userTypes,
        ownerIds,
        targetStart,
        targetEnd,
        orderTypeId,
        userSettings)
    },
    salesAnalysisInvoiceFields)

  function* watcher() {
    yield fork(myWatcher)
    yield fork(invoicesPivotTable)
    yield fork(invoiceItemsPivotTable)
    yield fork(invoiceHistoryPivotTable)
    yield fork(notInvoicedPivotTable)
    yield fork(purchaseInvoicesPivotTable)
    yield fork(invoiceSelectorInvoicesPivotTable)
    yield fork(invoiceSelectorItemsPivotTable)
    yield fork(receivedNotInvoicedPivotTable)
    yield fork(invoiceSalesAnalysisPivotTable)
  }

  return {
    watcher,
  }
}
